<template lang="pug">

div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    Query(
      :query="require('~/graphql/Article.gql').Articles"
      :limit="6"
      :initialValue="articles"
      :variables="({ first, after }) => ({ first, after, publishedIn: 'PRESS' })"
      :refetchOnRouteChange="true"
      v-slot="{ items }"
    )
      AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
        AppCard.is-work(:img="[{ srcset: item.thumb, type: 'image/jpg', ratio }]" :ratio="ratio" :title="item.title" :url="`/press/${item.slug}`")

  //- section.u-mt-md
  //-   AppTitle.u-mb-0(:title="$t('mantra2')")
  section.u-mt-md
    .grid.is-tablet-6.is-labs.u-mt-sm
      .column.u-mb-col
        AppCardBox
          AppLink(to="/press" :title="$t('press')"  class="cardBox-url")
          h4 {{$t('press')}}
          p {{$t('pressDesc')}}
      .column.u-mb-col
        AppCardBox
          AppLink(to="/contact" :title="$t('speaker')"  class="cardBox-url")
          h4 {{$t('speaker')}}
          p {{$t('speakerDesc')}}

  Homer
  .u-mb-md

</template>

<script>
import { Articles } from '~/graphql/Article.gql';
import Homer from '~/components/Homer';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import Query from '~/components/Query';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    Homer,
    AsymetricGrid,
    Query
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Articles,
      variables: {
        publishedIn: 'PRESS',
        first: 10
      }
    });

    return {
      articles: data.articles
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Press",
    "pageDesc": "Check the latest breaking news and press releases from inside Baianat and keep up with the updates moment by moment.",
    "mantra":"Recent news and |press releases.",
    "press":"Press kit",
    "pressDesc":"Download the official media kit of Baianat with all the imagery and information needed.",
    "speaker":"Request a speaker",
    "speakerDesc":"Let’s collaborate on delivering memorable events and powerful sessions and keynotes.",
    "mantra2":"Baianat in |media"
  },
  "ar": {
    "pageTitle":"الصحافة",
    "pageDesc": "تعرف على أحدث الأخبار العاجلة و التصريحات الصحفية التي تخص بيانات لتعرف كل ما يدور بداخلها لحظة بلحظة كأنك في وسط الفريق.",
    "mantra":"آخر الأخبار والبيانات |الصحفية. ",
    "press":"أدوات الصحافة",
    "pressDesc":"يمكنك تحميل أدوات المجموعة الخاصة بصحافة بيانات مع كل الصور والمعلومات المطلوبة.",
    "speaker":"اطلب متحدث",
    "speakerDesc":"دعنا نتعاون على تقديم فعاليات لا تنسى ومحاضرات قوية ومفيدة.",
    "mantra2":"بيانات في |الإعلام"
  }
}
</i18n>
